document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".custom-product-metafield-accordion_accordion-item");

  items.forEach((item) => {
    const header = item.querySelector(".custom-product-metafield-accordion_accordion-header");
    const content = item.querySelector(".custom-product-metafield-accordion_accordion__content");

    content.style.maxHeight = "0px";
    content.style.overflow = "hidden";
    content.style.transition = "max-height 0.2s ease";
    content.style.margin = "0";

    header.addEventListener("click", () => {
      const isOpen = item.classList.contains("active");

      if (isOpen) {
        content.style.maxHeight = "0px";
        item.classList.remove("active");
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
        item.classList.add("active");
      }
    });

    const index = item.getAttribute("data-index");
    if (index === "0") {
      item.classList.add("active");
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});